import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    bag: undefined,
    removedSoldOutProducts: false,
    updatingQuantity: false,
    promoCodeError: null,
    message: '',
};
export default createSlice({
    name: 'product',
    initialState: initialState,
    reducers: {
        updateBag: (state, action) => {
            state.bag = action.payload;
            state.customer = action.payload.customer;
        },
        setPromoCodeError: (state, action) => {
            state.promoCodeError = action.payload;
        },
        setRemovedSoldOutProducts: (state, action) => {
            state.removedSoldOutProducts = action.payload;
        },
        dismissExchangeAlert: (state) => {
            let bag = JSON.parse(JSON.stringify(state.bag));
            bag.exchangeModel.alert = false;
            state.bag = bag;
        },
        resetPromoCodeError: (state) => {
            state.promoCodeError = null;
        },
        startUpdatingQuantity: (state) => {
            state.updatingQuantity = true;
        },
        stopUpdatingQuantity: (state) => {
            state.updatingQuantity = false;
        },
        setMessage: (state, action) => {
            state.message = action.payload;
        },
    },
});
